import { InteractionStepType, InteractionStepConfig } from '@scale/shared/types/chat';
import { InstructionConfigurationComponent } from './InstructionConfigurationComponent';
import { InstructionViewComponent } from './InstructionViewComponent';
import { InstructionPinnedViewComponent } from './InstructionPinnedViewComponent';

import { StepDescriptor } from '../stepDescriptor/StepDescriptor';
import { registerStepDescriptor } from '../stepDescriptor/stepDescriptorContainer';
import { schema } from './validation';

class InstructionDescriptor extends StepDescriptor<InteractionStepType.Instruction> {
  type = InteractionStepType.Instruction;
  title = InteractionStepConfig[InteractionStepType.Instruction].title;
  description = InteractionStepConfig[InteractionStepType.Instruction].description;

  validationSchema = schema;

  ViewComponent = InstructionViewComponent;
  PinnedViewComponent = InstructionPinnedViewComponent;
  ConfigurationComponent = InstructionConfigurationComponent;

  getResponseTemplatePaths() {
    return [
      {
        path: 'output',
        label: 'Instruction',
      },
    ];
  }
}

registerStepDescriptor({
  type: InteractionStepType.Instruction,
  descriptor: new InstructionDescriptor(),
});
